import React, { Fragment } from 'react'
// import i18n from '../../i18n'
import { MENU_KEYS } from '../../utils/translation-constants'

import Side_DepositIcon from 'custom/assets/side-bar/Deposits.svg'
import Side_LoansIcon from 'custom/assets/side-bar/Loans.svg'
import Side_PaymentsIcon from 'custom/assets/side-bar/Payments.svg'
import Side_TransfersIcon from 'custom/assets/side-bar/Transfers.svg'
import Side_PortfolioIcon from 'custom/assets/side-bar/Portfolio.svg'
import Side_QuickLinksIcon from 'custom/assets/side-bar/QuickLinks.svg'
import Side_AccountsIcon from 'custom/assets/side-bar/Accounts_menu.svg'
import Side_RequestIcon from 'custom/assets/side-bar/Request.svg'
import Side_OtherServiceIcon from 'custom/assets/side-bar/OtherServices.svg'

import Account_RequestIcon from 'custom/assets/accounts/Request.svg'
import Account_DepositIcon from 'custom/assets/accounts/Deposit.svg'
import Account_Beneficiary_TransferIcon from 'custom/assets/accounts/Beneficiary_Transfer.svg'
import Account_DelinkIcon from 'custom/assets/accounts/Delink.svg'
import Account_LinkIcon from 'custom/assets/accounts/Link.svg'
import Account_PaymentIcon from 'custom/assets/accounts/Payment.svg'
import Account_Quick_TransferIcon from 'custom/assets/accounts/Quick_Transfer.svg'
import Account_Set_account_nameIcon from 'custom/assets/accounts/Set_account_name.svg'
import Account_StatementIcon from 'custom/assets/accounts/Statement.svg'
import Account_QRCodeIcon from 'custom/assets/accounts/QR_Code.svg'

import Desc_LinkAccountIcon from 'custom/assets/art-icons/LinkAccount.svg'
import Desc_DeLinkAccountIcon from 'custom/assets/art-icons/DelinkAccount.svg'

import Transfers_AddIcon from 'custom/assets/transfers/Add.svg'
import Transfers_ViewBeneficiariesIcon from 'custom/assets/transfers/View_Beneficiary.svg'
import Transfers_MakeTransferIcon from 'custom/assets/transfers/Beneficary_Transfer.svg'
import Transfers_DownloadIcon from 'custom/assets/transfers/Download.svg'
import Transfers_QuickTransferIcon from 'custom/assets/transfers/QuickTransfer.svg'
import RepeatIcon from 'custom/assets/common-icons/Repeat_Payment.svg'
import Transfers_ViewScheduledIcon from 'custom/assets/transfers/View_Scheduled.svg'

import Transfers_InternalIcon from 'custom/assets/transfers/Internal_Beneficiary.svg'
import Transfers_InternationalIcon from 'custom/assets/transfers/International_Beneficiary.svg'
import Transfers_DomesticIcon from 'custom/assets/transfers/Domestic_Beneficiary.svg'
import Transfers_RegionalIcon from 'custom/assets/transfers/Regional_Beneficiary.svg'

import D_BIIcon from 'custom/assets/quick-links/Bi_Statement.svg'
import D_MTIcon from 'custom/assets/quick-links/MT103.svg'
import D_ReceiptsIcon from 'custom/assets/quick-links/Receipts.svg'

import S_BranchIcon from 'custom/assets/quick-links/branch.svg'
import S_AboutUsIcon from 'custom/assets/quick-links/AboutUs.svg'
import S_ContactUsIcon from 'custom/assets/quick-links/contactUs.svg'
import S_FAQIcon from 'custom/assets/quick-links/faq.svg'
import S_SuggestionIcon from 'custom/assets/quick-links/suggestion.svg'

import Q_TCIcon from 'custom/assets/quick-links/Terms_Conditions.svg'

import R_ChequeBookIcon from 'custom/assets/cheque/Cheque_Book_Request.svg'
import R_ChequeStopIcon from 'custom/assets/cheque/Stop_Cheque_Payment.svg'
import R_ChequeStatusIcon from 'custom/assets/cheque/Cheque_Status.svg'
import R_ChequeBookStatusIcon from 'custom/assets/cheque/Cheque_Book_Request_Status.svg'

import R_ChequeIcon from 'custom/assets/cheque/Cheque.svg'
import R_SIIcon from 'custom/assets/cheque/Standing_Instruction.svg'

import P_ViewBillerIcon from 'custom/assets/payments/ViewBiller.svg'
import P_AddBillerIcon from 'custom/assets/payments/Add_Biller_Beneficiary.svg'
import P_ViewScheduledIcon from 'custom/assets/payments/View_Scheduled_Payments.svg'

import Other_DownloadCenterIcon from 'custom/assets/common-icons/Download_center.svg'
import Other_SupportCenterIcon from 'custom/assets/common-icons/Support_Center.svg'
import Q_OfferIcon from 'custom/assets/common-icons/Offer.svg'
import InstantTransferIcon from 'custom/assets/quickTransfer/InstantTransfer.svg'
import SendToMobileIcon from 'custom/assets/quickTransfer/SentToMobile.svg'

import PortfolioIcon from 'custom/assets/dashboard/portfolio.svg'
import LoanIcon from 'custom/assets/dashboard/loan.svg'
import DepositIcon from 'custom/assets/dashboard/deposit.svg'
import ExchangeRatesIcon from 'custom/assets/quick-links/exchange.svg'
import OtherServicesIcon from 'custom/assets/dashboard/otherServices.svg'
import TransfersIcon from 'custom/assets/dashboard/transfers.svg'
import AccountsIcon from 'custom/assets/dashboard/accounts.svg'
import PaymentsIcon from 'custom/assets/dashboard/payments.svg'

import BlackCardIcon from 'custom/assets/debit-card/BlockCard.svg'
import ReissueCardIcon from 'custom/assets/debit-card/ReissueCard.svg'
import RequestCardIcon from 'custom/assets/debit-card/RequestCard.svg'

import Account_CardlessCashIcon from 'custom/assets/accounts/Cardless_Cash.svg'

import GimacIcon from 'custom/assets/gimacpay/gimac.svg'
import GimacTransferIcon from 'custom/assets/gimacpay/transfer.svg'
import GimacPaymentIcon from 'custom/assets/gimacpay/payment.svg'
import GimacATMIcon from 'custom/assets/gimacpay/atm.svg'
import GimacRecieptsIcon from 'custom/assets/gimacpay/reciepts.svg'

export const MENU_OPTIONS = [
  {
    title: MENU_KEYS.ACCOUNTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: AccountsIcon,
    key: 'ACCOUNTS',
    link: '/accounts',
    s_icon: Side_AccountsIcon,
    children: [
      {
        title: MENU_KEYS.STATEMENT,
        desc: MENU_KEYS.VIEWSTMT,
        icon: Account_StatementIcon,
        key: 'STATEMENTS',
        link: '/statement',
        children: [],
      },
      {
        title: MENU_KEYS.PAYMENTS,
        desc: MENU_KEYS.PURCHASE_AIRTIME,
        icon: Account_PaymentIcon,
        key: 'PAYMENTS',
        link: '/payments',
        children: [],
      },
      {
        title: MENU_KEYS.QUICK_TRANSFER,
        desc: MENU_KEYS.QUICK_FT,
        icon: Account_Quick_TransferIcon,
        key: 'QUICK_TRANSFER',
        link: '/accounts/quick-pay',
        children: [
          {
            title: MENU_KEYS.INSTANT_TRANSFER,
            desc: MENU_KEYS.INSTANT_FT,
            icon: InstantTransferIcon,
            key: 'INSTANT',
            link: '/accounts/quick-pay/instant-transfer',
          },
          // {
          //     title: 'Send To Wallet',
          //     desc: 'Send money to your mobile money number',
          //     icon: SendToMobileIcon,
          //     key: 'WALLET',
          //     link: '/quick-pay/wallet',
          // },
        ],
      },
      {
        title: MENU_KEYS.TRANSFER_TO_BENE,
        desc: MENU_KEYS.TRANSFER_MONEY_BENE,
        icon: Account_Beneficiary_TransferIcon,
        key: 'MAKE_TRANSFER',
        link: '/beneficiary-transfers/transfers',
        children: [],
      },

      {
        title: MENU_KEYS.DEPOSITS,
        desc: MENU_KEYS.ACCOUNT_DEPOSIT,
        icon: Account_DepositIcon,
        key: 'ACCOUNT_DEPOSITS',
        link: '/deposits',
        children: [],
      },

      {
        title: MENU_KEYS.CARDLESS_CASH,
        desc: MENU_KEYS.GENERATE_TOKEN_DESC,
        icon: Account_CardlessCashIcon,
        key: 'CARDLESS_CASH',
        link: '/accounts/cardless-cash',
        children: [],
      },
    ],
  },
  {
    title: MENU_KEYS.PORTFOLIO,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: PortfolioIcon,
    key: 'PORTFOLIO',
    link: '/portfolio',
    s_icon: Side_PortfolioIcon,
    children: [],
  },
  {
    title: MENU_KEYS.TRANSFERS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: TransfersIcon,
    key: 'TRANSFER',
    link: '/beneficiary-transfers',
    s_icon: Side_TransfersIcon,
    children: [
      {
        title: MENU_KEYS.BENEFICIARY_ADD,
        desc: MENU_KEYS.ADD_BENEFICIARY,
        icon: Transfers_AddIcon,
        key: 'ADD',
        link: '/beneficiary-transfers/add-beneficiary',
        children: [
          {
            title: MENU_KEYS.INTERNAL_BENEFICIARY,
            desc: '',
            icon: Transfers_InternalIcon,
            key: 'INTERNAL_BENE',
            link: '/beneficiary-transfers/add-beneficiary/internal',
          },
          {
            title: MENU_KEYS.DOMESTIC_BENEFICIARY,
            desc: '',
            icon: Transfers_DomesticIcon,
            key: 'DOMESTIC_BENE',
            link: '/beneficiary-transfers/add-beneficiary/domestic',
          },
          {
            title: MENU_KEYS.REGIONAL_TRANSFER,
            desc: '',
            icon: Transfers_RegionalIcon,
            key: 'REGIONAL_BENE',
            link: '/beneficiary-transfers/add-beneficiary/regional',
          },
          {
            title: MENU_KEYS.INTERNATIONAL_BENEFICIARY,
            desc: '',
            icon: Transfers_InternationalIcon,
            key: 'INTERNATIONAL_BENE',
            link: '/beneficiary-transfers/add-beneficiary/international',
          },
        ],
      },
      {
        title: MENU_KEYS.QUICK_TRANSFER,
        desc: MENU_KEYS.QUICK_FT,
        icon: Account_Quick_TransferIcon,
        key: 'QUICK_TRANSFER',
        link: '/beneficiary-transfers/quick-pay',
        children: [
          {
            title: MENU_KEYS.INSTANT_TRANSFER,
            desc: MENU_KEYS.INSTANT_FT,
            icon: InstantTransferIcon,
            key: 'INSTANT',
            link: '/beneficiary-transfers/quick-pay/instant-transfer',
          },
          // {
          //     title: MENU_KEYS.SEND_TO_WALLET,
          //     desc: MENU_KEYS.SEND_MONEY_TO_MOBILE,
          //     icon: SendToMobileIcon,
          //     key: 'WALLET',
          //     link: '/quick-pay/wallet',
          // },
        ],
      },
      {
        title: MENU_KEYS.TRANSFER_TO_BENE,
        desc: MENU_KEYS.SEND_MONEY_TO_BENEFICIARY,
        icon: Transfers_MakeTransferIcon,
        key: 'MAKE_TRANSFER',
        link: '/beneficiary-transfers/transfers',
        children: [],
      },
      {
        title: MENU_KEYS.REPEAT_TRANSFER,
        desc: MENU_KEYS.MAKE_PAYMENT_AGAIN,
        icon: RepeatIcon,
        key: 'REPEAT_PAYMENT',
        link: '/beneficiary-transfers/repeat-payment',
        children: [],
      },
      {
        title: MENU_KEYS.MANAGE_BENIFICIARY,
        desc: MENU_KEYS.VIEW_BENEFICIARY_DETAILS,
        icon: Transfers_ViewBeneficiariesIcon,
        key: 'VIEW_BENEFICIARIES',
        link: '/beneficiary-transfers/view',
        children: [],
      },
      {
        title: MENU_KEYS.VIEW_SCHEDULED_TRANSFERS,
        desc: MENU_KEYS.VIEW_SCHEDULED_TRANSFERS_DESC,
        icon: Transfers_ViewScheduledIcon,
        key: 'SCHEDULED_TRANSFERS',
        link: '/beneficiary-transfers/viewScheduled',
        children: [],
      },
    ],
  },
  {
    title: MENU_KEYS.PAYMENTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: PaymentsIcon,
    key: 'PAYMENTS',
    link: '/payments',
    s_icon: Side_PaymentsIcon,
    children: [
      {
        title: MENU_KEYS.PAY_BILL,
        desc: MENU_KEYS.ADD_MAKE_BILL_PAYMENT,
        icon: PaymentsIcon,
        key: 'PAY_BILLS',
        link: 'payments/payBills',
        children: [],
      },
      {
        title: MENU_KEYS.ADD_BILLER,
        desc: MENU_KEYS.SERVICE_PROVIDER_BENE,
        icon: P_AddBillerIcon,
        key: 'ADD_BILLER',
        link: '/payments/add-biller',
        children: [],
      },

      {
        title: MENU_KEYS.VIEW_BILLER,
        desc: MENU_KEYS.ALL_PEROVIDER_BENE,
        icon: P_ViewBillerIcon,
        key: 'VIEW_BILLER',
        link: '/payments/biller-list',
        children: [],
      },
      {
        title: MENU_KEYS.VIEW_SCHEDULED_PAYMENTS,
        desc: MENU_KEYS.VIEW_SCHEDULED_PAYMENTS_DESC,
        icon: P_ViewScheduledIcon,
        key: 'SCHEDULED_PAYMENTS',
        link: '/payments/viewScheduled',
        children: [],
      },
    ],
  },

  {
    title: MENU_KEYS.GIMAC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    key: 'GIMACPAY',
    link: '/gimac-pay',
    s_icon: Side_PaymentsIcon,
    children: [
      {
        title: MENU_KEYS.TRANSFERS,
        desc: "Wallet To Wallet Transfer",
        icon: GimacTransferIcon,
        key: 'GIMAC_TRANSFER',
        link: '/gimac-pay/transfer',
        children: [],
      },
      {
        title: MENU_KEYS.PAYMENTS,
        desc: "Merchant Purchase",
        icon: GimacPaymentIcon,
        key: 'GIMAC_PAYMENT',
        link: '/gimac-pay/payment',
        children: [],
      },

      {
        title: MENU_KEYS.ATM_PROVISION,
        desc: "Without Card",
        icon: GimacATMIcon,
        key: 'GIMAC_ATM',
        link: '/gimac-pay/atm',
        children: [],
      },

      {
        title: "Transfer / Payment Reciepts",
        desc: "View and download your receipts",
        icon: GimacRecieptsIcon,
        key: 'GIMAC_RECIEPTS',
        link: '/gimac-pay/reciepts',
        children: [],
      },
    ],
  },

  {
    title: MENU_KEYS.DEPOSITS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: DepositIcon,
    key: 'DEPOSITS',
    link: '/deposits',
    s_icon: Side_DepositIcon,
    children: [],
  },
  {
    title: MENU_KEYS.LOANS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: LoanIcon,
    key: 'LOAN',
    link: '/loans',
    s_icon: Side_LoansIcon,
    children: [],
  },
  {
    title: MENU_KEYS.EXCHANGE_RATE,
    desc: MENU_KEYS.DESC_EXCHANGE_RATE,
    icon: ExchangeRatesIcon,
    key: 'EXCHANGE_RATES',
    link: '/exchange-rate',
    s_icon: Side_QuickLinksIcon,
    children: [],
  },
  {
    title: MENU_KEYS.REQUEST,
    desc: MENU_KEYS.CHECK_BOOK_ORDERS,
    icon: Account_RequestIcon,
    key: 'REQUESTS',
    link: '/requests',
    s_icon: Side_RequestIcon,
    children: [
      {
        title: MENU_KEYS.CHEQUE,
        desc: MENU_KEYS.ORDER_CANCEL_CHEQUE_STATUS,
        icon: R_ChequeIcon,
        key: 'CHEQUE',
        link: '/requests/cheque',
        children: [
          {
            title: MENU_KEYS.CHEQUE_BOOK,
            desc: MENU_KEYS.ORDER_CHEQUE_BOOK,
            icon: R_ChequeBookIcon,
            key: 'CHEQUE_BOOK',
            link: '/requests/cheque/cheque-book-request',
          },
          {
            title: MENU_KEYS.STOP_CHEQUE,
            desc: MENU_KEYS.DESC_STOP_CHECK,
            icon: R_ChequeStopIcon,
            key: 'STOP_CHEQUE',
            link: '/requests/cheque/stop-cheque-payment',
          },
          {
            title: MENU_KEYS.CHEQUE_STATUS,
            desc: MENU_KEYS.VIEW_CHEQUE_STATUS,
            icon: R_ChequeStatusIcon,
            key: 'CHEQUE_STATUS',
            link: '/requests/cheque/cheque-status',
          },
          {
            title: MENU_KEYS.CHEQUE_BOOK_STATUS,
            desc: MENU_KEYS.VIEW_CHEQUE_BOOK_STATUS,
            icon: R_ChequeBookStatusIcon,
            key: 'CHEQUE_BOOK_STATUS',
            link: '/requests/cheque/chequeBook-status',
          },
        ],
      },
      {
        title: MENU_KEYS.SI,
        desc: MENU_KEYS.CREATE_VIEW_SI,
        icon: R_SIIcon,
        key: 'SI',
        link: '/requests/standing-instruction',
      },
      {
        title: MENU_KEYS.DEBIT_CARD,
        desc: MENU_KEYS.DEBIT_CARD_DESC,
        icon: ReissueCardIcon,
        key: 'DEBIT_CARD',
        link: '/requests/debitCard',
        children: [
          {
            title: MENU_KEYS.DEBIT_CARD_REQUEST,
            desc: MENU_KEYS.DEBIT_CARD_REQUEST_DESC,
            icon: RequestCardIcon,
            key: 'DEBIT_CARD_REQUEST',
            link: '/requests/debitCard/cardRequest',
          },
          {
            title: MENU_KEYS.DEBIT_CARD_BLOCK,
            desc: MENU_KEYS.DEBIT_CARD_BLOCK_DESC,
            icon: BlackCardIcon,
            key: 'DEBIT_CARD_BLOCK',
            link: '/requests/debit-card/block-debit-card',
          },
          {
            title: MENU_KEYS.DEBIT_CARD_ISSUE,
            desc: MENU_KEYS.DEBIT_CARD_ISSUE_DESC,
            icon: ReissueCardIcon,
            key: 'DEBIT_CARD_ISSUE',
            link: '/requests/debitCard/cardIssue',
          },
        ],
      },
    ],
  },
  {
    title: MENU_KEYS.SUPPORT_CENTER,
    desc: MENU_KEYS.SUPPORT_CENTER_DESC,
    icon: Other_SupportCenterIcon,
    key: 'SUPPORT_CENTER',
    link: '/support-center',
    s_icon: Other_SupportCenterIcon,
    children: [
      {
        title: MENU_KEYS.BRANCH,
        desc: MENU_KEYS.FIND_ATM_LOCATION,
        icon: S_BranchIcon,
        key: 'BRANCH',
        link: '/branch',
      },
      {
        title: MENU_KEYS.FAQ,
        desc: MENU_KEYS.FREQUENTLY_ASKED_QUESTIONS,
        icon: S_FAQIcon,
        key: 'FAQ',
        link: '/faq',
      },

      {
        title: MENU_KEYS.SUGGESTIONS,
        desc: MENU_KEYS.FEEDBACK_AND_SUGGESTIONS,
        icon: S_SuggestionIcon,
        key: 'SUGGESTIONS',
        link: '/suggestion',
      },

      {
        title: MENU_KEYS.CONTACT,
        desc: MENU_KEYS.BANK_CONTACT_DETAILS,
        icon: S_ContactUsIcon,
        key: 'CONTACT_US',
        link: '/contact-us',
      },

      {
        title: MENU_KEYS.ABOUT,
        desc: MENU_KEYS.VISION_MISSION_BANK,
        icon: S_AboutUsIcon,
        key: 'ABOUT_US',
        link: '/about-us',
      },
    ],
  },
  {
    title: MENU_KEYS.OTHER_SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: OtherServicesIcon,
    key: 'OTHER_SERVICES',
    link: '/additional-links',
    s_icon: Side_OtherServiceIcon,
    children: [
      {
        title: MENU_KEYS.LINK_ACCOUNT,
        desc: MENU_KEYS.LINK_YOUR_ACCOUNT,
        icon: Account_LinkIcon,
        key: 'LINK_ACCOUNT',
        link: '/link-account',
        descIcon: Desc_LinkAccountIcon,
        children: [],
      },
      {
        title: MENU_KEYS.DELINK_ACCOUNT,
        desc: MENU_KEYS.REMOVE_YOUR_ACCOUNT,
        icon: Account_DelinkIcon,
        key: 'DE_LINK_ACCOUNT',
        link: '/deLink-account',
        descIcon: Desc_DeLinkAccountIcon,
        children: [],
      },
      {
        title: MENU_KEYS.ACCOUNT_NAME,
        desc: MENU_KEYS.ACCOUNT_NICKNAME,
        icon: Account_Set_account_nameIcon,
        key: 'SET_ACCOUNT_NAME',
        link: '/add-accountName',
        children: [],
      },

      {
        title: MENU_KEYS.QR,
        desc: MENU_KEYS.QR_DESC,
        icon: Account_QRCodeIcon,
        key: 'QR',
        link: '/quick-pay/qr',
        children: [],
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        desc: MENU_KEYS.DOWNLOAD_CENTER_DESC,
        icon: Other_DownloadCenterIcon,
        key: 'DOWNLOAD_CENTER',
        link: '/download-center',
        children: [
          {
            title: MENU_KEYS.DOWNLOAD_RECIEPT,
            desc: MENU_KEYS.VIEW_DOWNLOAD_RECEIPT,
            icon: D_ReceiptsIcon,
            key: 'RECEIPTS',
            link: '/receipts',
          },
          {
            title: MENU_KEYS.BI_STATEMENT,
            desc: MENU_KEYS.DOWNLOAD_DETAILED_STMT,
            icon: D_BIIcon,
            key: 'BI_STATEMENT',
            link: '/biStatement',
          },
          {
            title: MENU_KEYS.MT103,
            desc: MENU_KEYS.DOWNLOAD_RTGS_TT,
            icon: D_MTIcon,
            key: 'MT103',
            link: '/mt103',
          },
        ],
      },
      // {
      //   title: i18n.t(MENU_KEYS.CALCULATE),
      //   desc: 'Calculate loan eligibility and term deposit interest',
      //   icon: Q_CalculatorIcon,
      //   key: 'CALCULATOR',
      //   link: '/calculator',
      // },
      {
        title: MENU_KEYS.TC,
        desc: MENU_KEYS.TNC,
        icon: Q_TCIcon,
        key: 'TERMS_AND_CONDITIONS',
        link: '/terms-and-conditions',
        children: [],
      },
      {
        title: MENU_KEYS.OFFER,
        desc: MENU_KEYS.CURRENT_BANK_OFFER,
        icon: Q_OfferIcon,
        key: 'OFFERS',
        link: '/offers',
        children: [],
      },
    ],
  },
]
